<template>
  <v-card>
    <v-img :src="cover" aspect-ratio="2.75"></v-img>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{ title }}</h3>
        <div v-html="description"></div>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-btn flat color="primary" @click="$emit('add-score', game_id)">Ajouter un score</v-btn>
      <v-btn flat color="secondary" @click="$emit('go-ranking', game_id)">Voir le ranking</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['game_id', 'cover', 'title', 'description'],
};
</script>
